import { useEffect, useState } from 'react';

import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';

import '../styles/InviteChannelPopup.css';

export default function InviteChannelPopup({ open = false, close, inviteLink = '', isSubscribers = false }) {
  const [copyState, setCopyState] = useState('idle');

  useEffect(() => {
    if (open) {
      setCopyState('idle');
    }
  }, [open]);

  async function copyInviteLink() {
    if (!inviteLink) {
      setCopyState('error');
      return;
    }

    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(inviteLink);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = inviteLink;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setCopyState('copied');
    } catch {
      setCopyState('error');
    }
  }

  return (
    <GenericPopup open={open} className="channel-invite-popup generic-popup_content remove-scrollbar" opacity onBackgroundClick={close}>
      <div className="generic-popup__header">
        <h2 className="generic-popup__header-text">Invite members</h2>
        <XIcon className="generic-popup__close" onClick={close} />
      </div>

      <p className="channel-invite-popup__description">
        Share this link so people can join the channel
      </p>
      {isSubscribers ? (
        <p className="channel-invite-popup__description channel-invite-popup__description--subscribers">
          For subscriber channels, this invite grants the first month free and is unique per user.
        </p>
      ) : null}

      <button type="button" className="channel-invite-popup__copy-button" onClick={copyInviteLink}>
        <span className="channel-invite-popup__link">{inviteLink}</span>
        <span className="channel-invite-popup__copy-action">
          {copyState === 'copied' ? 'Copied' : 'Copy'}
        </span>
      </button>

      {copyState === 'error' ? (
        <p className="channel-invite-popup__error">Could not copy the link. Please copy it manually.</p>
      ) : null}
    </GenericPopup>
  );
}
